/**
 * @author Piotr Witek <piotrek.witek@gmail.com> (http://piotrwitek.github.io)
 * @copyright Copyright (c) 2016 Piotr Witek
 * @license MIT
 */
export * from './helpers';
// workarounds for missing features
export * from './returntypeof';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-typescript/module/index.js
// module id = null
// module chunks = 